import {supabase} from '../supabase/client';

const POST_FIELDS='id,translation_group_id,locale,slug,title,excerpt,body_markdown,category,tags,cover_image_path,cover_image_alt,seo_title,seo_description,status,scheduled_for,published_at,author_id,created_at,updated_at';
const IMAGE_TYPES=new Set(['image/jpeg','image/png','image/webp','image/avif']);
const EXTENSIONS={'image/jpeg':'jpg','image/png':'png','image/webp':'webp','image/avif':'avif'};

function client(){
  if(!supabase)throw new Error('Supabase is not configured.');
  return supabase;
}

export function slugify(value=''){
  return value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,120);
}

export async function getBlogEditor(){
  const {data:{user},error:userError}=await client().auth.getUser();
  if(userError)throw userError;
  if(!user)return null;
  const {data,error}=await client().from('blog_editors').select('user_id,role,is_active').eq('user_id',user.id).eq('is_active',true).maybeSingle();
  if(error)throw error;
  return data||null;
}

export async function listBlogPosts(){
  const {data,error}=await client().from('blog_posts').select(POST_FIELDS).order('updated_at',{ascending:false}).limit(200);
  if(error)throw error;
  return data||[];
}

export async function saveBlogPost(post){
  const {data:{user},error:userError}=await client().auth.getUser();
  if(userError||!user)throw new Error('Sign in again before saving.');
  const payload={
    locale:post.locale,title:post.title.trim(),slug:slugify(post.slug||post.title),
    excerpt:post.excerpt.trim(),body_markdown:post.body_markdown.trim(),
    category:post.category.trim(),tags:post.tags,cover_image_path:post.cover_image_path||null,
    cover_image_alt:post.cover_image_path?post.cover_image_alt.trim():null,
    seo_title:post.seo_title.trim()||null,seo_description:post.seo_description.trim()||null,
    status:post.status,scheduled_for:post.status==='scheduled'?new Date(post.scheduled_for).toISOString():null,
    published_at:post.status==='published'?(post.published_at||new Date().toISOString()):post.published_at||null
  };
  let query;
  if(post.id)query=client().from('blog_posts').update(payload).eq('id',post.id);
  else query=client().from('blog_posts').insert({...payload,author_id:user.id,created_by:user.id,updated_by:user.id});
  const {data,error}=await query.select(POST_FIELDS).single();
  if(error)throw error;
  return data;
}

export async function archiveBlogPost(post){
  return saveBlogPost({...post,status:'archived'});
}

export async function uploadBlogImage(file){
  if(!IMAGE_TYPES.has(file.type))throw new Error('Choose a JPEG, PNG, WebP, or AVIF image.');
  if(file.size>8388608)throw new Error('The image must be 8 MB or smaller.');
  const {data:{user},error:userError}=await client().auth.getUser();
  if(userError||!user)throw new Error('Sign in again before uploading.');
  const path=`${user.id}/${crypto.randomUUID()}.${EXTENSIONS[file.type]}`;
  const {error}=await client().storage.from('blog-media').upload(path,file,{contentType:file.type,upsert:false});
  if(error)throw error;
  return path;
}

export function getBlogImageUrl(path){
  if(!path)return '';
  return client().storage.from('blog-media').getPublicUrl(path).data.publicUrl;
}
